exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n.operationRow p:first-child {\n  margin: 0;\n}\n", ""]);

// exports
